<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
  >
    <div class="content">
      <div class="header">
        <template>
          <h1 class="title">{{ $t('create_work_instruction') }}</h1>
        </template>
      </div>

      <div class="columns">
        <div class="column">
          <b-field>
            <b-checkbox>DCI</b-checkbox>
          </b-field>
        </div>
        <div class="column is-three-quarters">
          <b-field>
            <b-input v-model="title"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-dropdown aria-role="list">
            <template #trigger="{ active }">
              <b-button
                label="Click me!"
                type="is-primary"
                :icon-right="active ? 'menu-up' : 'menu-down'"
              />
            </template>

            <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
              >Another action</b-dropdown-item
            >
            <b-dropdown-item aria-role="listitem"
              >Something else</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field>
            <b-checkbox>DCI</b-checkbox>
          </b-field>
        </div>
        <div class="column is-three-quarters">
          <b-field>
            <b-input v-model="title"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-dropdown aria-role="list">
            <template #trigger="{ active }">
              <b-button
                label="Click me!"
                type="is-primary"
                :icon-right="active ? 'menu-up' : 'menu-down'"
              />
            </template>

            <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
              >Another action</b-dropdown-item
            >
            <b-dropdown-item aria-role="listitem"
              >Something else</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field>
            <b-checkbox>DCI</b-checkbox>
          </b-field>
        </div>
        <div class="column is-three-quarters">
          <b-field>
            <b-input v-model="title"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-dropdown aria-role="list">
            <template #trigger="{ active }">
              <b-button
                label="Click me!"
                type="is-primary"
                :icon-right="active ? 'menu-up' : 'menu-down'"
              />
            </template>

            <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
              >Another action</b-dropdown-item
            >
            <b-dropdown-item aria-role="listitem"
              >Something else</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <b-field>
            <b-checkbox>DCI</b-checkbox>
          </b-field>
        </div>
        <div class="column is-three-quarters">
          <b-field>
            <b-input v-model="title"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-dropdown aria-role="list">
            <template #trigger="{ active }">
              <b-button
                label="Click me!"
                type="is-primary"
                :icon-right="active ? 'menu-up' : 'menu-down'"
              />
            </template>

            <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
              >Another action</b-dropdown-item
            >
            <b-dropdown-item aria-role="listitem"
              >Something else</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'CreateWIPackageModal',

  data() {
    return {
      title: '',
    };
  },

  methods: {
    onClose() {
      this.$emit('close');
    },
    onSave() {
      this.$emit('save', {
        title: this.title,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.columns {
  align-items: center;
}
</style>
